import UILoader from './ui-loader';
import './ui-loader.scss';

export default UILoader;
